var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    loader\n    ease-linear\n    rounded-full\n    border-gray-400 border-2 border-t-2\n    h-5\n    w-5\n    mr-1\n  "})}
var staticRenderFns = []

export { render, staticRenderFns }